import axiosLib from "axios";

const axios = axiosLib.create({

    baseURL: `${process.env.REACT_APP_BASE_URL}/`,
});

axios.interceptors.request.use(function (config) {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
});

export default axios;
